import script from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"

import "./FullscreenSpin.vue?vue&type=style&index=0&id=5a56d59c&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a56d59c"]])

export default __exports__